export const LANGUAGES_CODE = {
  EN: "en",
  FI: "fi",
  SV: "sv",
  PL: "pl"
};

export const LANGUAGES = [
  { name: "English", code: LANGUAGES_CODE.EN },
  { name: "Finnish", code: LANGUAGES_CODE.FI },
  { name: "Swedish", code: LANGUAGES_CODE.SV },
  { name: "Polish", code: LANGUAGES_CODE.PL }
];

export const LOCAL_STORAGE_ITEMS = {
  KITCHEN_SERVICE_URL: "KitchenServiceUrl",
  SHOW_PREPARATION_VIEW: "showPreparationView",
  SHOW_READY_TO_PICKUP_VIEW: "showReadyToPickUpView",
  LANGUAGE: "Language"
};



// WEBPACK FOOTER //
// ./src/utils/constants.js